<template>
    <div class="card itinerary">
        <div class="card-body px-2 px-sm-3 pb-0">
            <div class="d-flex mb-2">
                <h3 class="flex-grow-1">{{$t('common.itinerary.itinerary')}}</h3>
                <popper
                    placement="left"
                    :content="detailed ? $t('common.itinerary.showFewerDetails') : $t('common.itinerary.showMoreDetails')"
                    :hover="true"
                >
                    <font-awesome-icon
                        :icon="['fal', detailed ? 'circle-minus' : 'circle-plus']"
                        @click="detailed = !detailed"
                        class="fa-3x itinerary-detail-toggle text-secondary"
                    />
                </popper>
            </div>
            <div
                v-for="(originDestination, originDestinationIndex) in trip.pnr.originDestinations"
                :key="originDestination.id"
            >
                <origin-destination
                    :trip="trip"
                    :origin-destination="originDestination"
                    :origin-destination-index="originDestinationIndex"
                    :detailed="detailed"
                    @toggleDetailed="detailed = !detailed"
                />
            </div>
        </div>
    </div>
</template>

<script>
//External Components
import Popper from 'vue3-popper';

//P4MT Components
import OriginDestination from '@/components/itinerary/OriginDestination';

export default {
    name: 'Itinerary',
    components: {
        Popper,
        OriginDestination
    },
    data() {
        return {
            detailed: false
        }
    },
    props: {
        trip: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
    .itinerary {
        .itinerary-detail-toggle {
            cursor: pointer;
            -webkit-transition: opacity 0.15s ease-in-out 0s;
            transition: opacity 0.15s ease-in-out 0s;
            &:hover {
                opacity: 0.5;
            }
        }
    }
</style>